// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__31By8","label":"Completed_label__phyZ2"};